import { useState } from "react";

// ui
import {
  Typography,
  Box,
  Paper,
  Alert,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Checkbox,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { PoButton } from "./common/PoButton";
import { PoModalShell } from "./common/PoModalShell";

// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";

interface GetXLSXConfirmPaymentModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  getXLSXStatus: {
    status: "none" | "open" | "getting" | "result" | "loading" | "error";
    message: string;
    sale_company_id: number | null;
    sale_company_name: string;
    payment_year: string;
    payment_month: string;
  };
  setGetXLSXStatus: (getXLSXStatus: {
    status: "none" | "open" | "getting" | "result" | "loading" | "error";
    message: string;
    sale_company_id: number | null;
    sale_company_name: string;
    payment_year: string;
    payment_month: string;
  }) => void;
  getXLSXFunc: () => void;
  firstYear: number;
  thisYear: number;
  thisMonth: number;
  companyList: { id: number; sale_company_name: string }[];
}

export function GetXLSXConfirmPaymentModal(
  props: GetXLSXConfirmPaymentModalProps
) {
  const {
    onModal,
    swCloseModal,
    getXLSXStatus,
    setGetXLSXStatus,
    getXLSXFunc,
    firstYear,
    thisYear,
    thisMonth,
    companyList,
  } = props;

  const loginUser = useAtomValue(AppAtoms.loginUser);

  const createDayList = () => {
    let dayList = [];
    for (let i = 20; i <= 31; i++) {
      dayList.push(i.toString());
    }
    return dayList;
  };
  const createMonthList = () => {
    let monthList = [];
    for (let i = 1; i <= 12; i++) {
      monthList.push(i.toString());
    }
    return monthList;
  };
  const createYearList = () => {
    let yearList = [];
    for (let i = firstYear; i <= thisYear; i++) {
      yearList.push(i.toString());
    }
    return yearList;
  };
  const footerNode =
    getXLSXStatus.status === "open" ? (
      <>
        <PoButton
          data-testid="payment-confirm-xlsx-download"
          variant="secondary"
          disabled={
            loginUser?.authority !== "パートナー" &&
            getXLSXStatus.sale_company_id === null
          }
          onClick={() => {
            getXLSXFunc();
          }}
        >
          <Box>ダウンロード</Box>
          <FileDownloadIcon sx={{ marginLeft: "6px" }} fontSize="medium" />
        </PoButton>
        <PoButton
          data-testid="payment-confirm-xlsx-cancel"
          variant="secondary"
          onClick={swCloseModal}
        >
          <Box>キャンセル</Box>
        </PoButton>
      </>
    ) : getXLSXStatus.status === "error" ? (
      <PoButton
        data-testid="payment-confirm-xlsx-error-back"
        variant="secondary"
        onClick={() =>
          setGetXLSXStatus({
            status: "open",
            message: "",
            sale_company_id: null,
            sale_company_name: "",
            payment_year: thisYear.toString(),
            payment_month: thisMonth.toString(),
          })
        }
      >
        戻る
      </PoButton>
    ) : getXLSXStatus.status === "result" ? (
      <PoButton
        data-testid="payment-confirm-xlsx-result-close"
        variant="secondary"
        onClick={swCloseModal}
      >
        閉じる
      </PoButton>
    ) : undefined;
  return (
    <PoModalShell
      open={onModal}
      title="明細ダウンロード"
      onClose={swCloseModal}
      width="w760"
      testidPrefix="payment-confirm-xlsx"
      frameTestId="payment-confirm-xlsx-modal"
      footer={footerNode}
    >
        {getXLSXStatus.status === "open" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 0, flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
            <Paper elevation={1} sx={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
              <Box>
                <Box key={"paymentElsxAlert"} sx={{ margin: "0px 0px" }}>
                  <Alert severity="info">
                    <Box>管理者が発行した明細のみダウンロード可能です。</Box>
                  </Alert>
                </Box>
                <Box key={"paymentElsxBoxYear"} sx={{ margin: "30px 0px", display: "flex", flexDirection: "column", gap: "var(--sp-1)", paddingLeft: "30px", alignItems: "flex-start" }}>
                  <FormControl className="po-label">
                    明細年月
                  </FormControl>
                  <Box sx={{ display: "flex", gap: "16px" }}>
                    <FormControl sx={{ width: "200px" }}>
                      <InputLabel id="serch-input-label">年</InputLabel>
                      <Select
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.payment_year}
                        label={"年"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            payment_year: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createYearList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                    <FormControl sx={{ width: "150px" }}>
                      <InputLabel id="serch-input-label">月</InputLabel>
                      <Select
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.payment_month}
                        label={"月"}
                        onChange={(e) =>
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            payment_month: e.target.value,
                          })
                        }
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {createMonthList().map((input, i) => {
                          return (
                            <MenuItem
                              key={"input" + i}
                              value={input}
                              sx={{ textAlign: "right" }}
                            >
                              {input}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Box>
                </Box>

                {loginUser?.authority !== "パートナー" ? (
                  <Box
                    key={"paymentElsxSaleCompany"}
                    sx={{ margin: "30px 0px", display: "flex", flexDirection: "column", gap: "var(--sp-1)", paddingLeft: "30px", alignItems: "flex-start" }}
                  >
                    <FormControl className="po-label">
                      パートナー
                    </FormControl>
                    <FormControl sx={{ width: "380px" }}>
                      <Select
                        labelId="serch-input-label"
                        id="serch-input"
                        value={getXLSXStatus.sale_company_id}
                        onChange={async (e) => {
                          const sale_company_id = e.target.value as number;
                          let sale_company_name = "";
                          companyList.map((company, i) => {
                            if (company.id === sale_company_id) {
                              sale_company_name = company.sale_company_name;
                            }
                          });
                          setGetXLSXStatus({
                            ...getXLSXStatus,
                            sale_company_id,
                            sale_company_name,
                          });
                        }}
                        sx={{
                          height: "30px",
                          textAlign: "end",
                        }}
                      >
                        {companyList.map((company, i) => {
                          return (
                            <MenuItem
                              key={"company" + i}
                              value={company.id}
                              sx={{ textAlign: "right" }}
                            >
                              {company.sale_company_name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Box>
                ) : null}
              </Box>
            </Paper>
          </Typography>
        ) : getXLSXStatus.status === "loading" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 0 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "var(--sp-2)",
              }}
            >
              {/* cmd-po_1248: 待ち表示スピナー。span.po-spinnerはinline=親flex化で32x32を効かせる(先例 Dashboard.tsx:269) */}
              <span className="po-spinner" data-testid="xlsx-loading-spinner" />
              <Box sx={{ textAlign: "center" }}>明細取得中</Box>
            </Box>
          </Typography>
        ) : getXLSXStatus.status === "getting" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 0 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "var(--sp-2)",
              }}
            >
              {/* cmd-po_1248: 待ち表示スピナー。span.po-spinnerはinline=親flex化で32x32を効かせる(先例 Dashboard.tsx:269) */}
              <span className="po-spinner" data-testid="xlsx-loading-spinner" />
              <Box sx={{ textAlign: "center" }}>{getXLSXStatus.message}</Box>
            </Box>
          </Typography>
        ) : getXLSXStatus.status === "error" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 0 }}>
            <Alert severity="error">
              <Box>明細のダウンロードに失敗しました。</Box>
              <Box>明細が発行されていません。</Box>
            </Alert>
          </Typography>
        ) : getXLSXStatus.status === "result" ? (
          <Typography id="modal-modal-description" sx={{ mt: 2, mb: 0 }}>
            <Box>{getXLSXStatus.message}</Box>
          </Typography>
        ) : null}
    </PoModalShell>
  );
}
